import React from "react";
import { Helmet } from "react-helmet-async";
import PreguntasFrecuentes, {
  preguntasFrecuentes,
} from "./components/PreguntasFrecuentes";

export default function FaqPage() {
  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: preguntasFrecuentes.map((faq) => ({
      "@type": "Question",
      name: faq.pregunta,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.respuesta,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <html lang="es-MX" />
        <title>Preguntas frecuentes | Cursos y Certificaciones Fundación Nican</title>
        <meta
          name="description"
          content="Resuelve dudas sobre cursos de enfermería, quiropráctica, masoterapia y certificaciones SEP-CONOCER en Fundación Nican, Ixtapaluca."
        />
        <link rel="canonical" href="https://fundacionnican.com/faq" />
        <meta
          property="og:title"
          content="Preguntas frecuentes | Fundación Nican"
        />
        <meta
          property="og:description"
          content="Dudas frecuentes sobre cursos, certificaciones, requisitos, ubicación y becas."
        />
        <meta property="og:url" content="https://fundacionnican.com/faq" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      </Helmet>

      <main style={{ maxWidth: 960, margin: "0 auto", padding: "48px 16px" }}>
        <h1 className="mb-4">Preguntas frecuentes de Fundación Nican</h1>
        <PreguntasFrecuentes className="my-5" />
      </main>
    </>
  );
}
